const DATA = 'DATA';
const ACTION = 'ACTION';

export { DATA, ACTION };
